import BulkActionsToolbar from "./BulkActionsToolbar";

export default BulkActionsToolbar;